import { CommonModule } from '@angular/common';
import { Component, EventEmitter, NgModule, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SharedComponentsModule } from './../../../../shared-components.module';

@Component({
    selector: 'app-client-details-view',
    templateUrl: './client-details-view.component.html',
    standalone: false,
})
export class ClientDetailsViewComponent {
    @Output() action = new EventEmitter();

    // @ts-ignore TS7008
    client;

    constructor(private bsModalRef: BsModalRef) {}

    ok() {
        this.action.emit({ cancelled: false, client: this.client });
        this.bsModalRef.hide();
    }

    cancel() {
        this.action.emit({ cancelled: true });
        this.bsModalRef.hide();
    }
}

@NgModule({
    imports: [CommonModule, FormsModule, SharedComponentsModule],
    declarations: [ClientDetailsViewComponent],
})
export class ClientDetailsViewModule {}
